// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-ct-dark.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "CodeShow LapZ",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/CodeShowLapZ?mibextid=ZbWKwL",
    },
    {
      icon: <TwitterIcon />,
      link: "https://www.twitter.com/LahiruSenavira5?s=09",
    },
    {
      icon: <GitHubIcon />,
      link: "https://www.github.com/SE-LAPS",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/@CodeShowLapZ",
    },
  ],
  menus: [
    {
      name: "company",
      items: [
        { name: "careers", href: "https://www.linkedin.com/in/lahiru-senavirathna-39b11a215/" },
        { name: "about us", href: "https://www.bit.ly/Lahiru_Senavirathna" },
        {
          name: "Privacy Policy",
          href: "https://accounts.advocu.com/realms/advocu/protocol/openid-connect/auth?client_id=advocu-prod&redirect_uri=https%3A%2F%2Fgdsc.advocu.com%2Fhome%2Fapplications%2Fpreview%2F660fa8557892134aa9fe4c0f%3Fcommunityslug%3Dgdsc&state=99e55aad-9200-40af-8b6a-563687b4f1a7&response_mode=fragment&response_type=code&scope=openid&nonce=3262028a-1335-4ffa-82a3-e421898ef55d&code_challenge=JXqLTiH-dzKDP0P9psLSmr1jk02KCj97we5ADd-3SJU&code_challenge_method=S256",
        },
        {
          name: "Press & Media",
          href: "https://www.cloudskillsboost.google/public_profiles/a45b1cc2-b040-49a5-a31b-39487d2a9f7f",
        },
      ],
    },
    {
      name: "resources",
      items: [
        { name: "Blog", href: "https://www.bit.ly/Lahiru_Senavirathna" },
        { name: "Webinars", href: "https://developers.google.com/profile/u/LahiruSenavirathna" },
        { name: "Case Studies", href: "https://dev.to/lapz" },
        {
          name: "API Documentation",
          href: "https://stackoverflow.com/users/16341816/lahiru-senavirathna?tab=profile",
        },
      ],
    },
    {
      name: "help & support",
      items: [
        { name: "FAQs", href: "https://lahirusenavirathna.streamlit.app" },
        { name: "Product Tutorials", href: "https://www.bit.ly/Lahiru_Senavirathna" },
        { name: "Community Forum", href: "https://www.bit.ly/Lahiru_Senavirathna" },
        { name: "Customer Support ", href: "https://lahirusenavirathna.streamlit.app" },
      ],
    },
    {
      name: "contact",
      items: [
        { name: "Email", href: "lahirusenavirathna02@gmail.com" },
        { name: "LinkedIn", href: "https://www.linkedin.com/in/lahiru-senavirathna-39b11a215/" },
        { name: "Live Chat", href: "https://www.facebook.com/CodeShowLapZ?mibextid=ZbWKwL" },
        { name: "Whatsapp", href: "https://wa.me/94704894772" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All Rights Reserved. Copyright &copy; {date} - by{" "}
      <MKTypography
        component="a"
        href="https://www.bit.ly/Lahiru_Senavirathna"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        CodeShow LapZ
      </MKTypography>
      .
    </MKTypography>
  ),
};
